import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { NoAuthComponent } from './access-guard/no-auth/no-auth.component';
import { RouteGuard } from './route-guard/route-guard';
const AppRoutes: Routes = [

  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: 'login',pathMatch: 'full' },
  //{ path: '**', redirectTo: 'login' },
  { path: 'no-auth', component: NoAuthComponent },
  {
    path: 'content-protection', canActivate: [RouteGuard],
    children: [
      { path: '', loadChildren: './content-protection/content-protection.module#ContentProtectionModule' },
      { path: '**', loadChildren: './content-protection/content-protection.module#ContentProtectionModule' }
    ],
    pathMatch: 'prefix'
  },
  {
    path: '**',
    redirectTo: 'content-protection/tasks',
    pathMatch: 'prefix'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(AppRoutes,{useHash:true,initialNavigation:true})],
  //imports: [RouterModule.forRoot(AppRoutes)],
  exports: [RouterModule],
  providers: [RouteGuard],
  declarations: []
})

export class AppRoutesModule { }
